import { render, staticRenderFns } from "./M2hWeFitterBioAge.vue?vue&type=template&id=5bda2cda&scoped=true&"
import script from "./M2hWeFitterBioAge.vue?vue&type=script&lang=js&"
export * from "./M2hWeFitterBioAge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bda2cda",
  null
  
)

export default component.exports